<template>
	<div class="login">
		<div class="login-left">
			<div class="login-left__bg"></div>
			<div class="login-left-box">
				<div class="login-left-brand">
					<div class="login-left-brand__name">银合Pilot</div>
					<div class="login-left-brand__tag">数字员工</div>
				</div>
				<h1 class="login-left-title">让每个决策都有数据支撑</h1>
				<div class="login-left-subtitle">
					<div>让降本增效更轻松，更智能</div>
				</div>
				<div class="login-left-visual">
					<img class="login-left-img" src="../assets/login-left-illustration.png" alt="财务系统插图">
				</div>
			</div>
		</div>

		<div class="login-right">
			<div class="login-right-center">
				<div class="login-frame">
					<div class="login-frame-title">
						<div>登录</div>
					</div>
					<component v-model="currentComponent" :is="currentComponent"></component>
				</div>
			</div>

			<div class="login-right-copyright">
				© 2026 北京银合信科技有限公司. 保留所有权利. |
				<a href="https://www.yinhexin.cn/" target="_blank" rel="noopener noreferrer">京ICP备2023003240号</a>
			</div>
		</div>
	</div>
</template>

<script>
import ForgotPassword from "./login/ForgotPassword";
import Registered from "./login/Registered";
import LoginForm from "./login/LoginForm";

export default {
	name: "Login",
	components: { LoginForm, Registered, ForgotPassword },
	data() {
		return {
			currentComponent: "LoginForm"
		};
	}
};
</script>

<style lang="less">
#app {
	min-height: 100vh;
}

.login {
	width: 100vw;
	min-height: 100vh;
	display: flex;
	overflow: hidden;
	background: #fff;
	font-family: "MiSans", "MiSans Normal", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.login-left {
	width: 60vw;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	background: #edf4ff;
}

.login-left__bg {
	position: absolute;
	inset: 0;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.24)),
		url("../assets/login-left-bg.png") center center / cover no-repeat;
}

.login-left-box {
	width: min(640px, calc(100% - 120px));
	position: relative;
	z-index: 1;
	padding-top: 26px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	text-align: left;
}

.login-left-brand {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	align-self: flex-start;
}

.login-left-brand__name {
	color: #121212;
	font-size: 28px;
	font-family: "YouSheBiaoTiHei", "YouSheBiaoTiHei-Regular", "优设标题黑", "优设标题体", "Microsoft YaHei", sans-serif;
	font-weight: 400;
	line-height: 1;
	letter-spacing: -1px;
}

.login-left-brand__tag {
	height: 30px;
	padding: 0 14px;
	border-radius: 999px;
	display: inline-flex;
	align-items: center;
	background: linear-gradient(90deg, #4f83ff 0%, #3c72ff 100%);
	color: #fff;
	font-size: 14px;
	font-weight: 600;
}

.login-left-title {
	width: 100%;
	max-width: 591px;
	min-height: 84px;
	margin: 40px 0 0;
	color: #000;
	font-size: 50px;
	font-weight: 600;
	line-height: 1.2;
	letter-spacing: -1px;
}

.login-left-subtitle {
	width: 100%;
	max-width: 591px;
	margin-top: 12px;
	padding-left: 3px;
	color: #4c5c76;
	font-size: 18px;
	letter-spacing: 2px;
	line-height: 1.7;
}

.login-left-visual {
	width: 456px;
	max-width: 100%;
	height: 300px;
	margin-top: 54px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
}

.login-left-img {
	height: 300px;
	width: auto;
	display: block;
	filter: drop-shadow(0 26px 42px rgba(68, 116, 242, 0.18));
}

.login-left-visual__halo {
	position: absolute;
	left: 70px;
	right: 40px;
	bottom: 8px;
	height: 44px;
	background: radial-gradient(circle, rgba(60, 114, 255, 0.22), rgba(60, 114, 255, 0) 70%);
}

.login-left-visual__board {
	position: absolute;
	left: 118px;
	bottom: 24px;
	width: 250px;
	height: 52px;
	border-radius: 18px;
	background: linear-gradient(180deg, #71a5ff 0%, #3c72ff 100%);
	transform: skewX(-22deg);
	box-shadow: 0 24px 48px rgba(60, 114, 255, 0.22);
}

.login-left-visual__sheet {
	position: absolute;
	left: 186px;
	bottom: 86px;
	width: 132px;
	height: 178px;
	border-radius: 22px;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(233, 242, 255, 0.96)),
		repeating-linear-gradient(180deg, transparent, transparent 22px, rgba(129, 163, 255, 0.16) 22px, rgba(129, 163, 255, 0.16) 23px);
	box-shadow: 0 28px 56px rgba(56, 104, 232, 0.16);
	transform: perspective(520px) rotateX(22deg) rotateY(-20deg) rotateZ(-6deg);
}

.login-left-visual__sheet::before {
	content: "";
	position: absolute;
	left: 18px;
	top: 18px;
	width: 26px;
	height: 26px;
	border: 3px solid #3c72ff;
	border-radius: 50%;
}

.login-left-visual__sheet::after {
	content: "";
	position: absolute;
	right: 18px;
	bottom: 18px;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background: linear-gradient(180deg, #72a7ff 0%, #3c72ff 100%);
}

.login-left-visual__tab {
	position: absolute;
	border-radius: 18px;
	background: rgba(255, 255, 255, 0.78);
	backdrop-filter: blur(10px);
	box-shadow: 0 18px 34px rgba(92, 131, 229, 0.12);
}

.login-left-visual__tab--left {
	left: 92px;
	top: 74px;
	width: 86px;
	height: 66px;
	transform: perspective(400px) rotateY(15deg) rotateZ(-7deg);
}

.login-left-visual__tab--right {
	right: 62px;
	top: 92px;
	width: 102px;
	height: 74px;
	transform: perspective(400px) rotateY(-15deg) rotateZ(7deg);
}

.login-left-visual__chip {
	position: absolute;
	border-radius: 16px;
	box-shadow: 0 18px 34px rgba(79, 126, 236, 0.15);
}

.login-left-visual__chip--blue {
	left: 134px;
	top: 112px;
	width: 98px;
	height: 72px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(224, 235, 255, 0.96));
	transform: rotate(-12deg);
}

.login-left-visual__chip--blue::before,
.login-left-visual__chip--blue::after {
	content: "";
	position: absolute;
	left: 16px;
	right: 16px;
	height: 6px;
	border-radius: 999px;
	background: #7aa7ff;
}

.login-left-visual__chip--blue::before {
	top: 20px;
}

.login-left-visual__chip--blue::after {
	top: 34px;
	right: 34px;
}

.login-left-visual__chip--cyan {
	right: 118px;
	bottom: 92px;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: radial-gradient(circle at 30% 30%, #bdf4ff 0%, #59d0ff 38%, #2298ff 100%);
}

.login-left-visual__coin {
	position: absolute;
	left: 292px;
	bottom: 152px;
	width: 96px;
	height: 96px;
	border: 15px solid rgba(60, 114, 255, 0.15);
	border-top-color: rgba(60, 114, 255, 0.3);
	border-radius: 50%;
}

.login-left-visual__chart {
	position: absolute;
	right: 24px;
	top: 128px;
	display: flex;
	align-items: flex-end;
	gap: 8px;
	padding: 16px 14px;
	border-radius: 20px;
	background: rgba(255, 255, 255, 0.75);
	backdrop-filter: blur(10px);
	box-shadow: 0 18px 34px rgba(83, 122, 223, 0.14);
	transform: perspective(420px) rotateY(-16deg);
}

.login-left-visual__chart span {
	width: 10px;
	border-radius: 999px 999px 4px 4px;
	background: linear-gradient(180deg, #7eb4ff 0%, #3d69f0 100%);
}

.login-left-visual__chart span:nth-child(1) {
	height: 22px;
}

.login-left-visual__chart span:nth-child(2) {
	height: 36px;
}

.login-left-visual__chart span:nth-child(3) {
	height: 44px;
}

.login-left-visual__chart span:nth-child(4) {
	height: 28px;
}

.login-right {
	flex: 1;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: #fff;
}

.login-right-center {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
}

.login-frame {
	width: 400px;
	max-width: calc(100% - 48px);
}

.login-frame-title {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: 32px;
	font-size: 30px;
	font-weight: 600;
	color: #303133;
}

.login-right-copyright {
	padding: 32px;
	margin-bottom: 64px;
	text-align: center;
	color: #c0c4cc;
	font-size: 13px;
	line-height: 1.6;
}

.login-right-copyright a {
	color: inherit;
	text-decoration: none;
}

@media only screen and (max-width: 1024px) {
	.login-left {
		display: none;
	}

	.login-frame {
		width: 400px;
	}
}

@media only screen and (max-width: 500px) {
	.login-right-top {
		margin: 16px 12px;
	}

	.login-frame {
		width: 80%;
		max-width: none;
	}

	.login-right-copyright {
		padding: 20px 16px;
		margin-bottom: 24px;
	}
}
</style>
